import { LayoutStateInterface } from '.';

function state(): LayoutStateInterface {
  return {
    leftDrawerExpanded: false,
    rightDrawerExpanded: false,
    leftDrawerHovered: false,
    showing: 'FolioList',
    pricelistPlanningExpanded: false,
    popUpOpen: '',
    rightDrawerSearchParam: '',
    rightDrawerFilter: '',
    keepModalOpen: false,
    forceMoveFolioTab: '',
    showSpinner: false,
    isMoveToGuestsTab: false,
  };
}

export default state;
